import { BestOffering } from 'src/services/responseTypes/plansMetaDataResponse';
import {
  getGatingContentProperties,
  setGatingCustomProps
} from 'src/utils/analytics/gatingUtility';
import { setSessionStorage } from 'src/utils/browserStorageHandler';
import { REDIRECT_URL_TO_CONSUMPTION } from 'src/utils/constants/localStorageConstants';
import { getsubscribeToPremium } from 'src/utils/playerHelper';

import { gotoLogin, goToSubscription } from './playerCallbacks';
import { mixpanelObject } from '../../../utils/analytics/mixpanel/mixpanel';
import { gatingCTAClickEvent } from '../../../utils/analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from '../../../utils/analytics/mixpanel/mixpanelHelper';

export function showFreeMinutesGatingTimer({
  playerRef,
  allowedTime,
  gatingType,
  bestOfferingPlan
}: any) {
  const { messages = {} } = window.translationsAndConfigs || {};
  const { playerConfig = {} } = playerRef || {};
  const { country = 'IN' } = playerConfig || {};
  if (document.querySelector('.freeMinutesInfoContainer')) {
    return;
  }
  const gatingCustomProps = getGatingContentProperties(
    playerRef?.singlePlayDetails?.assetDetails,
    'top_left_cta'
  );
  setGatingCustomProps(gatingCustomProps);
  const freeMinutesInfoContainer = document.createElement('DIV');
  freeMinutesInfoContainer.className = 'freeMinutesInfoContainer';

  const freeMinutesInfoTimer = document.createElement('DIV');
  freeMinutesInfoTimer.className = 'freeMinutesInfoTimer';

  const freeMinutesTimerSpan = document.createElement('SPAN');

  freeMinutesInfoTimer.innerText = `${messages.FreeWatchEndsCounterHeading_Text}`;
  freeMinutesInfoTimer.appendChild(freeMinutesTimerSpan);

  const aLink = document.createElement('div');
  aLink.className = `subscribe-button buy-plan-btn`;
  aLink.innerText =
    gatingType.toLowerCase() === 'login'
      ? messages.Login_Button
      : `${getsubscribeToPremium(country, bestOfferingPlan as BestOffering)}`;
  aLink.addEventListener('click', () => {
    gatingType.toLowerCase() === 'login'
      ? loginClick(playerRef, gatingCustomProps)
      : buyPlanBtnClick(playerRef, gatingCustomProps);
  });

  const userIcon = document.createElement('span');
  userIcon.className =
    gatingType.toLowerCase() === 'login'
      ? 'user-icon login-icon'
      : ' user-icon subscribe-icon';
  aLink.prepend(userIcon);

  freeMinutesInfoContainer.appendChild(freeMinutesInfoTimer);
  freeMinutesInfoContainer.appendChild(aLink);

  const videoContainer = document.querySelector('.playerComp');
  if (videoContainer) videoContainer.appendChild(freeMinutesInfoContainer);

  function updateTimer() {
    const currentPlayerTime =
      playerRef?.videoPlayer?.videoPlayer?.currentTime() || 0;
    const timeRemaining = Math.max(allowedTime - currentPlayerTime, 0);

    const minutesStr = String(Math.floor(timeRemaining / 60)).padStart(2, '0');
    const secondsStr = String(Math.floor(timeRemaining % 60)).padStart(2, '0');

    const formattedTime = ` ${minutesStr}:${secondsStr}`;

    if (freeMinutesTimerSpan.innerText !== formattedTime) {
      freeMinutesTimerSpan.innerText = formattedTime;
    }

    if (timeRemaining <= 0) {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
      freeMinutesInfoContainer?.remove();
      playerConfig.triggerPopUp({
        name: 'gatingPopup',
        type: gatingType
      });
    }
  }

  const currentPlayerTime =
    playerRef?.videoPlayer?.videoPlayer?.currentTime() || 0;

  if (currentPlayerTime >= allowedTime) {
    freeMinutesInfoContainer?.remove();
    playerConfig.triggerPopUp({
      name: 'gatingPopup',
      type: gatingType
    });
    return;
  }

  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);
}

const loginClick = (playerRef: any, gatingCustomProps: any) => {
  setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
  clearCtaEventsProperty(mixpanelObject);
  gatingCTAClickEvent('Login CTA', {
    Timestamp: Math.floor(
      playerRef?.videoPlayer?.videoPlayer?.currentTime() || 0
    ),
    ...gatingCustomProps
  });
  gotoLogin();
};

const buyPlanBtnClick = (playerRef: any, gatingCustomProps: any) => {
  const { playerConfig = {} } = playerRef || {};
  const { country = 'IN', tvodObj = null } = playerConfig || {};
  if (
    window.isRevisedSubscriptionJourney &&
    country &&
    country.toLowerCase() === 'in'
  ) {
    clearCtaEventsProperty(mixpanelObject);
  } else {
    gatingCTAClickEvent('Subscribe CTA', {
      Timestamp: Math.floor(
        playerRef?.videoPlayer?.videoPlayer?.currentTime() || 0
      ),
      ...gatingCustomProps
    });
    goToSubscription({ country, tvodObj });
  }
};
